import React from "react";
import Guardrails from "../../components/pages/guardrails/Guardrails";

export default function GuardrailsPage() {
  return <Guardrails />;
}
